import styled from 'styled-components';
import { ImageInSyncIcon } from 'shared/icons/ImageInSyncIcon';

const GalleryRoot = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function InspectionPhotoPendingPlaceholder() {
  return (
    <GalleryRoot aria-label="Awaiting sync from Driver App">
      <ImageInSyncIcon fontSize="large" color="action" />
    </GalleryRoot>
  );
}
